import { Pressable, StyleSheet, Text, View } from 'react-native';

import { colors } from '@/src/theme/colors';
import { spacing } from '@/src/theme/spacing';

export type ProfileContentTab = 'posts' | 'garage';

export function ProfileContentTabs({
  activeTab,
  onChange,
}: {
  activeTab: ProfileContentTab;
  onChange: (tab: ProfileContentTab) => void;
}) {
  return (
    <View style={styles.tabs} accessibilityRole="tablist">
      <Pressable
        accessibilityRole="tab"
        accessibilityState={{ selected: activeTab === 'posts' }}
        onPress={() => onChange('posts')}
        style={[styles.tab, activeTab === 'posts' ? styles.activeTab : null]}
      >
        <Text
          style={[
            styles.tabText,
            activeTab === 'posts' ? styles.activeTabText : null,
          ]}
        >
          Posts
        </Text>
      </Pressable>
      <Pressable
        accessibilityRole="tab"
        accessibilityState={{ selected: activeTab === 'garage' }}
        onPress={() => onChange('garage')}
        style={[styles.tab, activeTab === 'garage' ? styles.activeTab : null]}
      >
        <Text
          style={[
            styles.tabText,
            activeTab === 'garage' ? styles.activeTabText : null,
          ]}
        >
          Garage
        </Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  tabs: {
    backgroundColor: colors.surface,
    borderColor: colors.border,
    borderRadius: 8,
    borderWidth: 1,
    flexDirection: 'row',
    gap: spacing.xs,
    marginTop: spacing.lg,
    padding: spacing.xs,
  },
  tab: {
    alignItems: 'center',
    borderRadius: 6,
    flex: 1,
    justifyContent: 'center',
    minHeight: 42,
    paddingHorizontal: spacing.md,
  },
  activeTab: {
    backgroundColor: colors.primary,
  },
  tabText: {
    color: colors.mutedText,
    fontSize: 15,
    fontWeight: '900',
  },
  activeTabText: {
    color: colors.surface,
  },
});
